export default "__VITE_ASSET__CL_BRxk7__"